import { useDispatch, useSelector } from "react-redux"
import { granjaApi } from "../api";
import { prepararFechaOp } from "../helpers/prepararFecha";

import { onLoandingInventario, onLoandingOp, onLoandingPlanilla, onLoandingProducto } from "../store";


export const useBusquedas = () => {


    const dispatch = useDispatch();
    const { inventarios } = useSelector( state => state.inventario );



    // Busquedas por Producto
    const busquedaPorProducto = async( text ) => {
        try {
            const { data } = await granjaApi.get(`/busqueda/xproducto/${ text }`);
            dispatch( onLoandingProducto(data.resultado) );
        } catch (error) {
            console.log(error);
        }
    }



    const inventarioTotalDeBodegas = async( uid ) => {
        try {
            const { data } = await granjaApi.get(`/busqueda/todo-inventario/${ uid }`);
            dispatch( onLoandingInventario( data.inventario ) );
            
        } catch (error) {
            console.log('Error al Cargar bodegas');
            console.log(error);
        }
    }


    // Busquedas por Op
    const busquedaPorOrdenesPedido = async( text ) => {
        try {
            const { data } = await granjaApi.get(`/busqueda/xop/${ text }`);
            const todasOp = prepararFechaOp(data.resultado);
            dispatch( onLoandingOp(todasOp) );
        } catch (error) {
            console.log('Error al Cargar Datos');
            console.log(error);
        }
    }






    const startSearchPlanillas = async( planilla, id ) => {
        try {
            const { data } = await granjaApi.get(`/busqueda/planilla/${ id }?start=${planilla.start}&end=${planilla.end}`);
            dispatch( onLoandingPlanilla( data.filtros ) );
        } catch (error) {
            console.log('Error al Cargar Granjas');
            console.log(error);
        }
    }


    const startLoadingNamePlanilla = async( nombre, id ) => {
        try {
            const { data } = await granjaApi.get(`/busqueda/planillaxname/${ id }/${nombre}`);
            dispatch( onLoandingPlanilla( data.resultado ) );
        } catch (error) {
            console.log('Error al Cargar Granjas');
            console.log(error);
        }
    }



    return {
        //Propiedades
        inventarios,

        //Metodos
        inventarioTotalDeBodegas,
        busquedaPorOrdenesPedido,
        startSearchPlanillas,
        startLoadingNamePlanilla,
        busquedaPorProducto,
    }


}
